import { render, staticRenderFns } from "./ExpireItem.vue?vue&type=template&id=3951fe87&scoped=true&"
import script from "./ExpireItem.vue?vue&type=script&lang=js&"
export * from "./ExpireItem.vue?vue&type=script&lang=js&"
import style0 from "./ExpireItem.vue?vue&type=style&index=0&id=3951fe87&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3951fe87",
  null
  
)

export default component.exports